<template id="layout">
	<transition name="fade" mode="out-in">
        <router-view></router-view>
	</transition>
</template>


<script>
export default {
    data() {
        return {
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/pages/common/contants.vue